import ExpandedSearch from './ExpandedSearch';
export default ExpandedSearch;